import Vue from 'vue';
import Component from 'vue-class-component';
import { G2S } from 'core/g2s';
import * as utils from 'core/utils';
import { Prop, Watch } from 'vue-property-decorator';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');
@WithRender
@Component
export class RegionSelectorComponent extends Vue {

    @Prop()
    markets: []; 

    // selectedMarketCode: any = null;
    selectedMarket: any = null;
    isUserCancelSelection: boolean = false;
    // regionWasSelected: boolean = false;
    marketsTranslates: any = [
        {marketCode: 'en', text:'Select your local website to display the best flight options', button: 'Accept'},
        {marketCode: 'ae', text:'حدد موقع الويب المحلي الخاص بك لعرض أفضل خيارات الرحلات الجوية', button: 'قبول'},
        {marketCode: 'az', text:'Ən yaxşı uçuş seçimlərini göstərmək üçün yerli veb saytınızı seçin', button: 'Qəbul edin'},
        {marketCode: 'br', text:'Selecione seu site local para exibir as melhores opções de voo', button: 'Aceitar'},
        {marketCode: 'ca', text:'Select your local website to display the best flight options', button: 'Accept'},
        {marketCode: 'de', text:'Wählen Sie Ihre lokale Website aus, um die besten Flugoptionen anzuzeigen', button: 'Annehmen'},
        {marketCode: 'dk', text:'Vælg dit lokale websted for at vise de bedste flymuligheder', button: 'Acceptere'},
        {marketCode: 'es', text:'Seleccione su sitio web local para mostrar las mejores opciones de vuelo', button: ' Aceptar'},
        {marketCode: 'fr', text:'Sélectionnez votre site Web local pour afficher les meilleures options de vol', button: 'Accepter'},
        {marketCode: 'gr', text:'Επιλέξτε τον τοπικό σας ιστότοπο για να εμφανίσετε τις καλύτερες επιλογές πτήσης', button: 'Αποδέχομαι'},
        {marketCode: 'hu', text:'Válassza ki helyi webhelyét a legjobb repülési lehetőségek megjelenítéséhez', button: 'Elfogad'},
        {marketCode: 'id', text:'Pilih situs web lokal Anda untuk menampilkan opsi penerbangan terbaik', button: 'Menerima'},
        {marketCode: 'il', text:'Select your local website to display the best flight options', button: 'Accept'},
        {marketCode: 'in', text:'Select your local website to display the best flight options', button: 'Accept'},
        {marketCode: 'it', text:'Seleziona il tuo sito web locale per visualizzare le migliori opzioni di volo', button: 'Accettare'},
        {marketCode: 'kz', text:'Выберите региональный сайт для отображения оптимальных перелетов', button: 'Далее'},
        {marketCode: 'mx', text:'Seleccione su sitio web local para mostrar las mejores opciones de vuelo', button: 'Aceptar'},
        {marketCode: 'my', text:'Pilih tapak web tempatan anda untuk memaparkan pilihan penerbangan terbaik', button: 'Terima'},
        {marketCode: 'nl', text:'Selecteer uw lokale website om de beste vluchtopties weer te geven', button: 'Aanvaarden'},
        {marketCode: 'pl', text:'Wybierz lokalną stronę internetową, aby wyświetlić najlepsze opcje lotów', button: 'Zaakceptować'},
        {marketCode: 'pt', text:'Selecione seu site local para exibir as melhores opções de voo', button: 'Aceitar'},
        {marketCode: 'ro', text:'Selectați site-ul dvs. web local pentru a afișa cele mai bune opțiuni de zbor', button: 'Accept'},
        {marketCode: 'ru', text:'Выберите региональный сайт для отображения оптимальных перелетов', button: 'Далее'},
        {marketCode: 'se', text:'Välj din lokala webbplats för att visa de bästa flygalternativen', button: 'Acceptera'},
        {marketCode: 'tr', text:'En iyi uçuş seçeneklerini görüntülemek için yerel web sitenizi seçin', button: 'Kabul'}
    ];
    
    mounted(){        
        try {
            this.isUserCancelSelection = Boolean(utils.Cookies.getIsUserCancelSelectionLanguage());
            // this.selectedMarketCode = utils.Cookies.getUserLanguage();
        } catch (error) {
            this.isUserCancelSelection = false;
        }
        if(this.markets) {            
            this.selectedMarket = this.markets.find(code=>{
                return G2S.config.clientDevice.language.includes((<any>code).MarketCode);
                // if(this.selectedMarketCode){
                //     return this.selectedMarketCode == (<any>code).MarketCode;
                // } else{
                // }
            });
        }
        
    }

    get isRegionSelectionActive() {
        if(this.$route.path !== '/' || this.isUserCancelSelection) {
            return false;
        }
        if(!G2S.config.clientDevice.language.includes(G2S.config.marketCode)) {
            (<any>this).$ga.sendEvent('market', 'msg', 'market.msg');
            return true;
        }
        // if(G2S.config.clientDevice.language.includes(G2S.config.marketCode) && this.selectedMarketCode && this.selectedMarketCode !== G2S.config.marketCode){
        //     (<any>this).$ga.sendEvent('market', 'msg', 'market.msg');
        //     return true;
        // }
        // if(!G2S.config.clientDevice.language.includes(G2S.config.marketCode) && this.selectedMarketCode && this.selectedMarketCode == G2S.config.marketCode){
        //     return false;
        // }
        // if(!G2S.config.clientDevice.language.includes(G2S.config.marketCode) && this.selectedMarketCode && this.selectedMarketCode !== G2S.config.marketCode){
        //     (<any>this).$ga.sendEvent('market', 'msg', 'market.msg');
        //     return true;
        // }
    }

    get selectedMarketTranslate() {
        return this.marketsTranslates.find(market=> G2S.config.clientDevice.language.includes((<any>market).marketCode))
            || this.marketsTranslates.find(market=> 'en' === (<any>market).marketCode);
    }

    onChangeMarket(market) {
        this.selectedMarket = market;
    }

    close() {
        utils.Cookies.setIsUserCancelSelectionLanguage(this.selectedMarket.MarketCode);
        (<any>this).$ga.sendEvent('market', 'cliсk.x', 'market.cliсk.x');
        this.isUserCancelSelection = true;
        // this.regionWasSelected = true;
    }

    apply() {
        (<any>this).$ga.sendEvent('market', 'cliсk.further', 'market.cliсk.further');
        utils.Cookies.setIsUserCancelSelectionLanguage(this.selectedMarket.MarketCode);

        if(this.selectedMarket.MarketCode != G2S.config.marketCode){
            (<any>this).$ga.sendEvent('global.header', `market.change.${G2S.config.marketCode}_${this.selectedMarket.MarketCode}`, `global.header.market.change.${G2S.config.marketCode}_${this.selectedMarket.MarketCode}`);
            setTimeout(() => {
                location.href = this.selectedMarket.Desktop;
            }, 100);
        } else {
            // utils.Cookies.setUserLanguage(this.selectedMarket.MarketCode);
            // this.regionWasSelected = true;
            this.isUserCancelSelection = true;
        }
    }
}